/*! js-cookie v3.0.1 | MIT */

/* eslint-disable no-var */
function assign(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      target[key] = source[key];
    }
  }


  return target;
}
/* eslint-enable no-var */

/* eslint-disable no-var */


var defaultConverter = {
  read: function (value) {
    if (value[0] === '"') {
      value = value.slice(1, -1);
    }

    return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function (value) {
    return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
  }
};
/* eslint-enable no-var */

/* eslint-disable no-var */

function init(converter, defaultAttributes) {
  function set(key, value, attributes) {
    if (typeof document === 'undefined') {
      return;
    }

    attributes = assign({}, defaultAttributes, attributes);

    if (typeof attributes.expires === 'number') {
      attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
    }

    if (attributes.expires) {
      attributes.expires = attributes.expires.toUTCString();
    }

    key = encodeURIComponent(key).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
    var stringifiedAttributes = '';

    for (var attributeName in attributes) {
      if (!attributes[attributeName]) {
        continue;
      }

      stringifiedAttributes += '; ' + attributeName;

      if (attributes[attributeName] === true) {
        continue;
      } // Considers RFC 6265 section 5.2:
      // ...
      // 3.  If the remaining unparsed-attributes contains a %x3B (";")
      //     character:
      // Consume the characters of the unparsed-attributes up to,
      // not including, the first %x3B (";") character.
      // ...


      stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
    }

    return document.cookie = key + '=' + converter.write(value, key) + stringifiedAttributes;
  }

  function get(key) {
    if (typeof document === 'undefined' || arguments.length && !key) {
      return;
    } // To prevent the for loop in the first place assign an empty array
    // in case there are no cookies at all.

    var cookies = document.cookie ? document.cookie.split('; ') : [];
    var jar = {};

    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      var value = parts.slice(1).join('=');

      try {
        var foundKey = decodeURIComponent(parts[0]);
        jar[foundKey] = converter.read(value, foundKey);

        if (key === foundKey) {
          break;
        }
      } catch (e) {}
    }

    return key ? jar[key] : jar;
  }

  return Object.create({
    set: set,
    get: get,
    remove: function (key, attributes) {
      set(key, '', assign({}, attributes, {
        expires: -1
      }));
    },
    withAttributes: function (attributes) {
      return init(this.converter, assign({}, this.attributes, attributes));
    },
    withConverter: function (converter) {
      return init(assign({}, this.converter, converter), this.attributes);
    }
  }, {
    attributes: {
      value: Object.freeze(defaultAttributes)
    },
    converter: {
      value: Object.freeze(converter)
    }
  });
}

var api = init(defaultConverter, {
  path: '/'
});

window['ThemeSection_LocationCheck'] = settings => {
  return {
    authenticated: false,
    mode: settings.mode,
    date_format: settings.date_format,
    minimum_age: settings.minimum_age,
    redirect_url: settings.redirect_url,
    shop_location: settings.shop_location,
    available_countries: settings.available_countries,
    month: '',
    day: '',
    year: '',
    date: '',
    cookie: api.get('localisationStoreSet'),
    user_country: '',
    country_icon: '',
    shop_country: Shopify.country,
    isSelected: false,

    get fullDate() {
      return `${this.month}/${this.day}/${this.year}`;
    },

    init(){  
      Alpine.store('modals').close('nav');
      // get user country
      this.saveUserCountry(this.available_countries);      
    },

    mounted() {
      initTeleport(this.$root);
      Alpine.store('modals').register('locationCheck', 'modal');



      if (this.redirect_url === null) {
        this.redirect_url = 'https://www.shayandblue.com';
      }

      var arrayLength = this.available_countries.length;
      //for (var i = 0; i < arrayLength; i++) {
          //console.log(this.available_countries[i].title);
      //}

      document.addEventListener('shopify:section:select', e => {
        if (!e.target.querySelector('[data-section="location-check"]')) return;
        this.showSectionInThemeEditor();
      });

      if (Shopify.designMode && this.isSelected) {
        this.showSectionInThemeEditor();
      }
    },

    // process and save in variable
    async saveUserCountry(available_countries) {

        var userCountryData = api.get('userLocation');

        if(typeof userCountryData !== "undefined"){
          userCountryData = JSON.parse(userCountryData);
          //console.log(userCountryData);
        }else {
          userCountryData = await this.fetchUserCountry();
              api.set('userLocation', JSON.stringify(userCountryData), {
                expires: 50 // 50 days
              });
        }
        


        this.user_country = userCountryData.country;
        let countryMatch = false;

        // if user country does not match the shop locale and there's no cookie set
        if(this.user_country != this.shop_country && this.cookie !== 'true'){
          Alpine.store('modals').open('locationCheck');
        }

        let arrayLength = available_countries.length;
        for (var i = 0; i < arrayLength; i++) {

            if(this.user_country == available_countries[i].country_code){
                // set the user country as the one in customiser if country code matches
                this.user_country = available_countries[i].title;
                this.redirect_url = available_countries[i].country_link;
                this.country_icon = available_countries[i].country_icon;
                countryMatch = true;
            }
        }

        if(countryMatch === false) {
          for (var i = 0; i < arrayLength; i++) {
              if(available_countries[i].country_code == 'NA'){
                  // set the user country as the global option
                  this.user_country = available_countries[i].title;
                  this.redirect_url = available_countries[i].country_link;
                  this.country_icon = available_countries[i].country_icon;
                  countryMatch = true;
              }
          }
        }
      
    },

    // get user country data from IP
    async fetchUserCountry() {
       return await (await fetch('https://ipinfo.io/json?token=d30e5823e15d00')).json();
    },
    
    showSectionInThemeEditor() {
      this.isSelected = true;
      Alpine.store('modals').open('locationCheck');
    },

    approveStore() {
      // redirect and take the current url with you to the new store
      window.location = this.redirect_url+window.location.pathname;
    },

    denyStore() {
      Alpine.store('modals').close('locationCheck');
      api.set('localisationStoreSet', 'true', {
        expires: 1 // 1 day
      });
    },

    isCountryModal(){
      var isCountryModal = Alpine.store('modals').getCountryModal();
      return isCountryModal;
    }
    
  };
};
